// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-page {
  min-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
}

.search-bar-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 48px 20px 8px;
}

.kiosk-link-button {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--surface);
  border: 1px solid var(--border);
  color: var(--text-muted);
  font-size: 14px;
  flex-shrink: 0;
  transition: all var(--fast) var(--ease);
}

.kiosk-link-button:hover {
  color: var(--text);
  background: var(--surface-hover);
  border-color: var(--border-strong);
}

.search-bar {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  max-width: 560px;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-full);
  padding: 6px 8px 6px 20px;
  box-shadow: var(--shadow-sm);
  transition: border-color var(--fast) var(--ease), box-shadow var(--fast) var(--ease);
}

.search-bar:focus-within {
  border-color: var(--accent);
  box-shadow: var(--shadow-accent);
}

.search-bar .search-icon {
  color: var(--text-muted);
  font-size: 15px;
}

.search-bar input {
  flex: 1 1;
  border: none;
  background: transparent;
  color: var(--text);
  font-size: 15px;
  padding: 10px 0;
  min-width: 0;
}

.search-bar input:focus {
  outline: none;
}

.search-bar input::placeholder {
  color: var(--text-faint);
}

.search-bar button {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--surface-hover);
  color: var(--text-muted);
  transition: all var(--fast) var(--ease);
  flex-shrink: 0;
  font-size: 14px;
}

.search-bar button:hover {
  color: var(--text);
  background: var(--border-strong);
}

.search-bar .search-submit-button {
  background: linear-gradient(120deg, var(--accent-start), var(--accent-end));
  color: #1a0e05;
}

.search-bar .search-submit-button:hover {
  box-shadow: var(--shadow-accent);
}

.search-empty {
  margin-top: 60px;
  color: var(--text-muted);
  font-size: 15px;
  text-align: center;
}

.search-file-input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  overflow: hidden;
}

.search-page .movie-grid.wrap {
  grid-template-columns: repeat(6, 1fr);
}

@media (max-width: 1200px) {
  .search-page .movie-grid.wrap {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 720px) {
  .search-page .movie-grid.wrap {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 480px) {
  .search-page .movie-grid.wrap {
    grid-template-columns: repeat(2, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SearchPage.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;EACf,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,iCAAiC;EACjC,yBAAyB;EACzB,4BAA4B;EAC5B,oFAAoF;AACtF;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,wBAAwB;EACxB,uCAAuC;EACvC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,2EAA2E;EAC3E,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".search-page {\n  min-height: calc(100vh - 64px);\n  display: flex;\n  flex-direction: column;\n}\n\n.search-bar-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 48px 20px 8px;\n}\n\n.kiosk-link-button {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  color: var(--text-muted);\n  font-size: 14px;\n  flex-shrink: 0;\n  transition: all var(--fast) var(--ease);\n}\n\n.kiosk-link-button:hover {\n  color: var(--text);\n  background: var(--surface-hover);\n  border-color: var(--border-strong);\n}\n\n.search-bar {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  max-width: 560px;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-full);\n  padding: 6px 8px 6px 20px;\n  box-shadow: var(--shadow-sm);\n  transition: border-color var(--fast) var(--ease), box-shadow var(--fast) var(--ease);\n}\n\n.search-bar:focus-within {\n  border-color: var(--accent);\n  box-shadow: var(--shadow-accent);\n}\n\n.search-bar .search-icon {\n  color: var(--text-muted);\n  font-size: 15px;\n}\n\n.search-bar input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  color: var(--text);\n  font-size: 15px;\n  padding: 10px 0;\n  min-width: 0;\n}\n\n.search-bar input:focus {\n  outline: none;\n}\n\n.search-bar input::placeholder {\n  color: var(--text-faint);\n}\n\n.search-bar button {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--surface-hover);\n  color: var(--text-muted);\n  transition: all var(--fast) var(--ease);\n  flex-shrink: 0;\n  font-size: 14px;\n}\n\n.search-bar button:hover {\n  color: var(--text);\n  background: var(--border-strong);\n}\n\n.search-bar .search-submit-button {\n  background: linear-gradient(120deg, var(--accent-start), var(--accent-end));\n  color: #1a0e05;\n}\n\n.search-bar .search-submit-button:hover {\n  box-shadow: var(--shadow-accent);\n}\n\n.search-empty {\n  margin-top: 60px;\n  color: var(--text-muted);\n  font-size: 15px;\n  text-align: center;\n}\n\n.search-file-input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  overflow: hidden;\n}\n\n.search-page .movie-grid.wrap {\n  grid-template-columns: repeat(6, 1fr);\n}\n\n@media (max-width: 1200px) {\n  .search-page .movie-grid.wrap {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n\n@media (max-width: 720px) {\n  .search-page .movie-grid.wrap {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 480px) {\n  .search-page .movie-grid.wrap {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
